
<div
  :id="vnodeId"
  ref="draftWrapperRef"
  :data-vnode-id="vnodeId"
  class="cvt-editor-text"
  :class="editorClasses"
  draggable="false"
  @mouseover="target"
  @click="enableEditor"
  @dblclick="resizeContent"
  @contextmenu="(event) => showContextMenuIfNotEditing(event)"
  @dragstart="dragstart"
  @dragend="dragend"
>
  <drag-and-drop-zone :z-index="dropzoneZIndex" @dropped="addElementToSide" />

  <!-- main vdom node -->
  <div
    class="draft-editor font-style-normalText"
    :class="stylesheet.classes.cvtListContainer"
  >
    <div class="froala-editor" v-html="contentsHTML" />
  </div>
  <template v-if="showActionButtonsOnClick && !isGridBuilder">
    <!--THis is only here because of freshwork in v1 gridbuilder,
    once they migrate to v2 or v3, it will become irrelevant-->
    <action-buttons
      v-if="selected"
      @duplicate="duplicateAndValidate"
      @remove="removeAndValidate"
    />
  </template>
</div>
